import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionHeaderGapModule } from 'src/app/shared/section-header-gap/section-header-gap.module';
import { ImageTitleModule } from '@studiobuki/web-core/lib/image-title';
import { InputModule } from '@studiobuki/web-core/lib/input';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { BookFormModule } from '@studiobuki/web-core/lib/book-form';
import { ImageTitleCustomModule } from '@studiobuki/web-core/lib/image-title-custom';
import { ProductModule } from 'src/app/shared/product/product.module';
import { SectionProductsModule } from 'src/app/shared/section-products/section-products.module';
import { GiftUsePageComponent } from './gift-use-page.component';
import { ContentModule } from '../gift-thanks-page/components/content/content.module';
import { SectionGiftHeaderComponent } from './components/section-gift-header/section-gift-header.component';
import { SectionGiftUseComponent } from './components/section-gift-use/section-gift-use.component';
import { BookFormDialogComponent } from './dialogs/book-form-dialog/book-form-dialog.component';
import { BookSelectDialogComponent } from './dialogs/book-select-dialog/book-select-dialog.component';

@NgModule({
  declarations: [
    GiftUsePageComponent,
    SectionGiftHeaderComponent,
    SectionGiftUseComponent,
    BookFormDialogComponent,
    BookSelectDialogComponent,
  ],
  imports: [
    CommonModule,
    ContentModule,
    SectionHeaderGapModule,
    ImageTitleModule,
    InputModule,
    ButtonModule,
    ProductModule,
    BookFormModule,
    SectionProductsModule,
    ImageTitleCustomModule,
  ],
})
export class GiftUsePageModule {}
